<template>
    <div>
        <!--components has been registered by: common/plugins/ComponentPlugin.js-->
        <NewsInfoModal></NewsInfoModal>
        <SearchBankVeritransModal></SearchBankVeritransModal>
        <ModalConfirm></ModalConfirm>
        <AgreementNewsModal></AgreementNewsModal>
        <SearchBank></SearchBank>
        <SearchBranch></SearchBranch>
        <InformModal></InformModal>
        <ServerErrorModal></ServerErrorModal>
        <UnsupportedBrowserModal></UnsupportedBrowserModal>
        <RegisterPasskeyResult/>
        <OtpMailChoosing/>
        <OtpInput/>
        <OtpInputResult/>
        <FidoAuthenticateUnsupported/>
        <ConfirmDeletePasskey/>
        <DeletePasskeyResult/>
        <RegisterPasskeyModal/>
        <RegisterPasskeyModalResult/>
    </div>
</template>

<script>
    export default {
        name: "ComposeModal",
    }
</script>